import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/immutable';
import SMSHelper from 'smshelper';
import { compose, withProps } from 'recompose';

import * as textAreaStyles from './textAreaStyles.css';
import formControl from './formControl';
import { withTranslation } from 'react-i18next';

const CharacterCounter = ({ length, maxLength }) => (
  <div className={
    classNames(
      'pull-right',
      textAreaStyles.counter,
    )}
  >
    <span>{length} {maxLength && ` / ${maxLength}`}</span>
  </div>
);

CharacterCounter.defaultProps = {
  maxLength: undefined,
};

CharacterCounter.propTypes = {
  length: PropTypes.number.isRequired,
  maxLength: PropTypes.number,
};

const SMSCounter = ({ value, maxLength }) => {
  const parts = SMSHelper.parts(value);
  const length = SMSHelper.count(value);
  return (
    <div className={
      classNames(
        'pull-right',
        textAreaStyles.counter,
      )}
    >
      <span>{parts} SMS | {length} {maxLength && ` / ${maxLength}`}</span>
    </div>
  );
};

SMSCounter.defaultProps = {
  maxLength: undefined,
};

SMSCounter.propTypes = {
  value: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
};

function TextArea({
  input,
  isEditable,
  testID,
  maxLength,
  showCounter,
  showSMSCounter,
  rows,
  defaultValue,
  autoFocus,
}) {
  if (isEditable === false) {
    return <div className={textAreaStyles.textAreaValue}>{input.value || '-'}</div>;
  }

  return (
    <div className={textAreaStyles.container}>
      <textarea
        {...input}
        className="form-control"
        id={name}
        data-testid={testID}
        maxLength={maxLength}
        rows={rows}
        defaultValue={defaultValue}
        autoFocus={autoFocus}
      />
      {showCounter && (
        <CharacterCounter length={input.value.length} maxLength={maxLength} />
      )}
      {showSMSCounter && (
        <SMSCounter value={input.value} maxLength={maxLength} />
      )}
    </div>
  );
}

TextArea.defaultProps = {
  isEditable: true,
  testID: undefined,
  maxLength: undefined,
  showCounter: false,
  showSMSCounter: false,
  rows: undefined,
};

TextArea.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  isEditable: PropTypes.bool.isRequired,
  testID: PropTypes.string,
  maxLength: PropTypes.number,
  showCounter: PropTypes.bool,
  showSMSCounter: PropTypes.bool,
  rows: PropTypes.number,
};

export default compose(
  withTranslation(),
  withProps(({ input, forceCheck, meta, t }) => {
    if (!forceCheck) {
      return {};
    }

    if ((!input.value || input.value.size === 0)) {
      return {
        indicator: true,
        meta: {
          ...meta,
          touched: true,
          error: t('Fältet måste fyllas i.'),
        },
      };
    }

    return {};
  }),
  formControl,
)(TextArea);
